import { render } from "./MasterTreeTransfer.vue?vue&type=template&id=44b33e13&scoped=true"
import script from "./MasterTreeTransfer.vue?vue&type=script&lang=js"
export * from "./MasterTreeTransfer.vue?vue&type=script&lang=js"

import "./MasterTreeTransfer.vue?vue&type=style&index=0&id=44b33e13&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b33e13"]])

export default __exports__